import { HTMLAttributes } from 'react';
import styles from './Spinner.module.css';

export type SpinnerProps = HTMLAttributes<HTMLDivElement>;

export function Spinner({ className, ...rest }: SpinnerProps) {
  const classNames = className ? `${styles.grow} ${className}` : styles.grow;
  return <div className={classNames} {...rest} />;
}
